import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveZIndex(theme, screenWidth, zIndexSupport) {
    var result = {};
    if (zIndexSupport.zIndex !== undefined) {
        result.zIndex = resolveResponsiveValue(theme, screenWidth, zIndexSupport.zIndex);
    }
    return result;
}
//# sourceMappingURL=ZIndexResolver.js.map